import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';
import { ActivateEmailResponse } from 'store/api/types';
import { activateEmail } from 'store/api/user/userActions';

import { ActivateEmail } from './ActivateEmail';
import { ActivateEmailProps } from './ActivateEmail.types';

const mapDispatchToProps = (
  dispatch: Dispatch,
  {
    match: {
      params: { token },
    },
  }: ActivateEmailProps,
) => ({
  onActivateEmail: () => dispatch<Promise<ActivateEmailResponse>>(activateEmail(token)),
});

export const ActivateEmailContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(ActivateEmail);
